import React from "react";
import logoNavarra from "../../assets/img/logo-gob-navarra-agenda-2030.png";
import icoNext from "../../assets/img/ico-seguent.svg";
import logoInm from "../../assets/img/logo-inm.png";
import { Link } from "react-router-dom";
import { translate } from "../../assets/js/functions";

const HomeFooter = () => {
  return (
    <footer className="has-background-primary has-text-white">
      <div className="py-5 px-6 is-flex gap-5">
        <Link
          to={"/exposition"}
          className="has-text-weight-bold is-inline-flex is-align-items-center gap-3 link-dn"
        >
          {translate('Iniciar exposición')}
          <img src={icoNext} alt="" width="31" height="30" />
        </Link>

        <div className="logos is-flex is-align-items-center gap-5">
          <a href="https://www.navarra.es/">
            <img
              loading="lazy"
              src={logoNavarra}
              alt="Gobierno de Navarra. Nafarroako Gobernua. Agenda 2030"
              width="187"
              height="41"
              className="is-block"
            />
          </a>
          <a href="https://pazyconvivencia.navarra.es/es/inm">
            <img
              loading="lazy"
              src={logoInm}
              alt="Instituto Navarro de la Memoria. Nafarroako Memoriaren Institutua"
              width="138"
              height="32"
              className="is-block"
            />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default HomeFooter;
